import React from 'react';
import { colors } from 'styles/colors';

export type Props = {
  fillColor?: string;
  className?: string;
  direction?: 'right' | 'left' | 'top' | 'bottom';
};

export const ThinArrowIcon: React.FC<Props> = ({ fillColor = colors.gray600, className, direction = 'right' }) => {
  const directionClasses = {
    right: 'rotate-0',
    left: 'rotate-180',
    top: '-rotate-90',
    bottom: 'rotate-90',
  };
  const directionClass = directionClasses[direction];
  return (
    <svg width="5" height="10" viewBox="0 0 5 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={`${className} ${directionClass}`}>
      <path
        d="M0.418719 10C0.361248 10 0.30583 9.98438 0.252463 9.95315C0.199097 9.92191 0.151888 9.88398 0.110837 9.83936C0.0779967 9.80366 0.0513139 9.76127 0.0307884 9.71218C0.010263 9.6631 0 9.60732 0 9.54485C0 9.4913 0.010263 9.43998 0.0307884 9.3909C0.0513139 9.34181 0.0779967 9.29942 0.110837 9.26372L4.05172 4.97992L0.110837 0.696117C0.0779967 0.660419 0.0513139 0.618028 0.0307884 0.568942C0.010263 0.519857 0 0.468541 0 0.414993C0 0.352521 0.010263 0.296742 0.0307884 0.247657C0.0513139 0.198572 0.0779967 0.15618 0.110837 0.120481C0.143678 0.0847836 0.186782 0.0557785 0.240148 0.0334673C0.293514 0.0111561 0.344828 0 0.394089 0C0.45156 0 0.504926 0.0111561 0.554187 0.0334673C0.603448 0.0557785 0.648604 0.0847836 0.689655 0.120481L4.88916 4.6988C4.922 4.73449 4.94869 4.77689 4.96921 4.82597C4.98974 4.87506 5 4.92637 5 4.97992C5 5.03347 4.98974 5.08478 4.96921 5.13387C4.94869 5.18295 4.922 5.22535 4.88916 5.26104L0.689655 9.83936C0.656815 9.87506 0.617816 9.90852 0.57266 9.93976C0.527504 9.971 0.480296 9.99108 0.431035 10H0.418719Z"
        fill={fillColor}
      />
    </svg>
  );
};
